<template>
  <the-dissension />
</template>

<script>
import TheDissension from '@/components/TheDissension'

export default {
  components: { TheDissension },
}
</script>
